import { z } from "zod"

export const MechanicSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
})

export type Mechanic = z.infer<typeof MechanicSchema>

/** The logged-in user's linked Personal at a store, null for shared/unlinked logins */
export interface CurrentMechanic {
  mechanicId: string | null
}
